/*
  The corporate enquiry form part is in:
    `frontend/src/containers/components/EnquiryForm/index.ts`
*/

import { IContext } from "@src/context";
import { vhmarea, vhmproperty } from "@src/proto/jsonapi";
import { jsonFetch } from "@src/utils/fetch";
import searchDataHelper from "../SearchPopup/searchDataHelper";
import { fetchAreaJson } from "../SearchResult/propertiesFetcher/allProperties";

export function setupCorporate(context: IContext) {
  const container = document.querySelector(".freestyle-corporate");

  if (container == null) {
    return;
  }

  fetchAreaAndPrefectureCount(context).then(([areaJson, prefectureCount]) => {
    const area = searchDataHelper.pureConvertAreaResp(areaJson);
    const count = prefectureCount;

    container
      .querySelectorAll(".freestyle-corporate-place-item")
      .forEach((item) => {
        // get region ids from `data-region` attribute
        const regions: number[] =
          item
            .getAttribute("data-region")
            ?.split(",")
            .map((x) => parseInt(x)) ?? [];

        // update region name in title
        item
          .querySelector(".freestyle-corporate-place-item-title")
          ?.insertAdjacentHTML(
            "beforeend",
            regions.map((region) => area.rIdRRegionMap[region].name).join("・")
          );

        // update prefecture data in table
        const totalRow = item.querySelector("tbody tr:last-child");

        let prefectureRows = "";
        let totalPropertyCount = 0;
        let totalRoomCount = 0;

        regions.forEach((region) => {
          const prefectures = area.rIdPrefectureMap[region];

          prefectures.forEach((prefecture) => {
            const name = prefecture.name;
            const id = prefecture.id;
            const propertyCount =
              count.propertyCount?.prefecture?.[id ?? ""] ?? 0;
            const roomCount = count.roomCount?.prefecture?.[id ?? ""] ?? 0;

            totalPropertyCount += propertyCount;
            totalRoomCount += roomCount;

            prefectureRows += `<tr>
              <td>${name}</td>
              <td>${formatNumber(propertyCount)}</td>
              <td>${formatNumber(roomCount)}</td>
            </tr>`;
          });
        });

        totalRow?.insertAdjacentHTML("beforebegin", prefectureRows);
        totalRow?.insertAdjacentHTML(
          "beforeend",
          `<td>${formatNumber(totalPropertyCount)}</td>
           <td>${formatNumber(totalRoomCount)}</td>`
        );
      });
  });

  function formatNumber(number: number) {
    return number.toLocaleString(context.locale || "ja-JP");
  }
}

function fetchPrefectureCountJson(): Promise<vhmproperty.FeedStats> {
  return jsonFetch(
    `/api/property_feed_stats.json`
  ) as Promise<vhmproperty.FeedStats>;
}

function fetchAreaAndPrefectureCount(
  context: Pick<IContext, "locale" | "errorNotifier">
): Promise<[vhmarea.IArea, vhmproperty.FeedStats]> {
  return Promise.all([fetchAreaJson(context), fetchPrefectureCountJson()]);
}
